// @flow
export const addItem: string = '/orders/add_to_cart';
export const addDyor: string = '/orders/add_dyor_combination_to_cart';
export const apiCart: string = '/api/orders/cart.json';
export const cart: string = '/orders/cart';
export const validate: string = '/api/orders/validate.json';
export const updateShippingState: string =
  '/api/orders/update_shipping_state.json';
export const createOrder: string = '/api/orders.json';
